import { render, staticRenderFns } from "./ShortlistStartup.vue?vue&type=template&id=5d74db58&"
import script from "./ShortlistStartup.vue?vue&type=script&lang=js&"
export * from "./ShortlistStartup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports